import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Blogres 2k8",
  "description": "",
  "published": "2008-06-21T00:00:00.000Z",
  "redirect_from": ["/blog/blogres-2k8/swizec/102"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So far so good, blogres is being fun and I was given some strange liquid to drink - smelled like coffee, but tasted well even on just a single pack of sugar ... very strange. Also, and I'm very very frustrated about this, for a blogers' congress these hallway computers from a fancy sponsor could have some other browser than merely IE7 installed ... fucking bastards ... or merely morons?`}</p>
    <p><strong parentName="p">{`Update at 13:06 from hallway crappy dell:`}</strong></p>
    <p>{`The forum on large company - blogger integration was rather interesting. Surprising how captivating a 120 slide presentation can be when done even half right. Sadly there wasn't so much foruming going on as it was a presentation by two guys, but there were something interesting tid bits thrown around at the end. Now let's go eat another free chocolate bar.`}</p>
    <p><strong parentName="p">{`Update at 13:16:`}</strong></p>
    <p>{`Found out the strange liquid from before was coffee. Doesn't taste very drinkable this time around ... probably because the caffeine isn't as terribly needed as before. Strange how sometimes we find out just how much such basic scientific facts hold true.`}</p>
    <p><strong parentName="p">{`Update at 16:11:`}</strong></p>
    <p>{`Got back from lunch and finally managed to get to a computer. Four isn't by far enough even though rumour seems to be flying around that there were many more people around last year ... who knows, I wasn't around to notice. Anyway, the previous three speeches were kind of boring, but I `}<em parentName="p">{`was`}</em>{` surprised by just how much a speech on law can be fun to listen to. In another strange twist of events I found out that having 300 visits a month isn't at all too shabby as far as blogs go in slovenia ... always thought I had a fairly unread blog myself.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      